import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const Footer = ({ variant = 'light' }) => {
  const isLight = variant === 'light';
  
  return (
    <footer className={`py-6 px-4 ${isLight ? 'bg-[#F5E6D3]/30' : 'bg-[#2C2C2C]'}`}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className={isLight ? 'text-[#4A154B]' : 'text-white'}>
            <span className="font-serif text-lg">Salon O</span>
            <span className="text-[#C9A689] text-xs ml-2">Rewards</span>
          </div>
          
          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/privacy-policy" 
              className={`hover:text-[#C9A689] transition-colors ${isLight ? 'text-gray-600' : 'text-white/70'}`}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className={`hover:text-[#C9A689] transition-colors ${isLight ? 'text-gray-600' : 'text-white/70'}`}
            >
              Terms of Service
            </Link>
            <a 
              href="mailto:info@oculusai.io" 
              className={`hover:text-[#C9A689] transition-colors flex items-center gap-1 ${isLight ? 'text-gray-600' : 'text-white/70'}`}
            >
              <Mail className="w-4 h-4" />
              Contact Us
            </a>
          </div>
          
          {/* Copyright */}
          <p className={`text-xs ${isLight ? 'text-gray-500' : 'text-white/50'}`}>
            © {new Date().getFullYear()} SalonO. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
